export default {
  movies: [],
};
